import React from 'react';
import {DownloadIcon} from "presentation/common/components/style-guide/pdf-viewer/thumbnail-item/download";
import {downloadFile} from "presentation/common";
import ReactTooltip from 'react-tooltip';
import clsx from "clsx";

import styles from './styles.module.scss';

export const DocItem = ({doc}) => {

  return (
    <>
      <ReactTooltip
        id="downloadItemTooltip"
        type="info"
        effect="solid"
        textColor="var(--primary)"
        border
        borderColor="var(--primary)"
        backgroundColor="white">
        Descargar
      </ReactTooltip>

      <div>
        <div className="border border-gray-200 p-1 rounded">
          <h3 className="text-sm">{doc.name}</h3>
          <p className={clsx("text-sm", styles.attach)}>Adjuntado: {doc.createAt}</p>
          <div className="flex w-full gap-2 justify-end items-center">
            <DownloadIcon
              className="outline-none cursor-pointer"
              data-tip data-for="downloadItemTooltip"
              onClick={() => downloadFile(doc.downloadUrl, doc.name)}/>
          </div>
        </div>
      </div>
    </>
  );
};
